
<ng-container *ngIf="{ result: checkResult$ | async} as checkResult">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
        
        <div class="container">
            <div class="row" *ngIf="showAboutEmployee">
                <div class="col-md-6">
                    <app-search [(ngModel)]="aboutEmployee"
                        [title]="'USER_BULK_INSERT_DIALOG.ABOUT_EMPLOYEE_LABEL' | translate" [showAddButton]="false" [inlineButtons]="false" [isAllowSearch]="true" [config]="searchEmployeeConfig"
                    ></app-search>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <h2>{{ 'USER_BULK_INSERT_DIALOG.EMAIL_LIST_TITLE' | translate }}</h2>
                    <mat-form-field appearance="outline">
                        <textarea matInput [(ngModel)]="inputText" (ngModelChange)="inputFieldChanged()" [placeholder]="'USER_BULK_INSERT_DIALOG.EMAIL_LIST_PLACEHOLDER' | translate"></textarea>
                      </mat-form-field>
                </div>
                <div class="col-md-6">
                    <h2>{{ 'USER_BULK_INSERT_DIALOG.IDENTIFIED_EMPLOYEES_TITLE' | translate }}</h2>
                    <div class="list-items list-employee" >
                        <div *ngIf="checkResult.result">
                            <div *ngFor="let item of checkResult.result.validEmployees">
                                {{ item.name + " " + (item.employeeIdentifier ?? '') }}
                            </div>
                        </div>
                    </div>

                    <h2>{{ 'USER_BULK_INSERT_DIALOG.INVALID_EMAILS_TITLE' | translate }}</h2>
                    <div class="invalid-message">{{ 'USER_BULK_INSERT_DIALOG.INVALID_EMAILS_MESSAGE' | translate }}</div>
                    <div class="list-items list-invalid-emails">
                        <div *ngIf="checkResult.result">
                            <div *ngFor="let item of checkResult.result.invalidEmails">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </div>
    <div mat-dialog-actions class="flex-h flex-end">
        <button mat-flat-button color="primary" #okButton (click)="ok(checkResult.result.validEmployees)" cdkFocusInitial [disabled]="!isAllowSubmit">{{ 'GENERAL.OK' | translate }}</button>
        <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
</ng-container>
